import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

// Define port constant (for reference only)
const PORT = 3000;
console.log(`React app will run on port: ${PORT}`);

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container);
root.render(<App />);
